import Markdoc, { Config } from "@markdoc/markdoc";
import { DataSourceInputType } from "../../helper/dataSource/DataSourceInputType";
import { DataSourceInstructionVariables } from "../../helper/dataSource/getDataSourceInstructions";

export const importAction = {
  selfClosing: true,
  transform(_node, config: Config) {
    const variables = config.variables as DataSourceInstructionVariables;

    const importMethod = variables.importMethod;

    const action = importMethod === DataSourceInputType.Api ? "Sync" : "Import";

    return new Markdoc.Tag("strong", {}, [action]);
  },
};
